/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, Input, OnInit } from '@angular/core';
import {
  LoadingController,
  ModalController,
  ToastController,
} from '@ionic/angular';
import { catchError } from 'rxjs/operators';
import { FieldInfo } from '../map/map.component';
import {
  AnalyticsService,
  RentalRequestData,
} from '../services/analytics.service';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-rental-request-modal',
  templateUrl: './rental-request-modal.component.html',
  styleUrls: ['./rental-request-modal.component.scss'],
})
export class RentalRequestModalComponent implements OnInit {
  @Input() fieldInfo: FieldInfo;

  nameInput: string = '';
  phoneInput: string = '';
  dateInput: string = '';

  currentDate: any = '2021-08';

  monthNames: string[] = [
    'Января',
    'Февраля',
    'Марта',
    'Апреля',
    'Мая',
    'Июня',
    'Июля',
    'Августа',
    'Сентября',
    'Октября',
    'Ноября',
    'Декабря',
  ];

  constructor(
    private modalController: ModalController,
    private analyticsService: AnalyticsService,
    private loadingService: LoadingService,
    private toastController: ToastController,
    private loadingController: LoadingController
  ) {}

  ngOnInit() {
    this.currentDate = new Date().toISOString();
  }

  sendRentalRequest() {
    this.loadingService.showLoader();

    const date = new Date(this.dateInput);
    const rentalRequestData: RentalRequestData = {
      name: this.nameInput,
      userPhone: this.phoneInput,
      fieldPhone: this.fieldInfo.phone.find(
        (phone) => !phone.includes('(044)')
      ),
      date: `${date.toLocaleDateString('ru').replace('.2021', '')}, ${date
        .getHours()
        .toString()}:${
        date.getMinutes() !== 0 ? date.getMinutes().toString() : '00'
      }`,
      address: this.fieldInfo.address,
      fieldTitle: this.fieldInfo.title,
    };
    console.log('rentalRequestData: ', rentalRequestData);

    this.analyticsService
      .sendRentalRequest(rentalRequestData)
      .pipe(catchError(() => this.openErrorToast()))
      .subscribe((res) => {
        console.log('res: ', res);
        setTimeout(() => {
          this.loadingService.completeLoader().then(() => this.closeModal());
          this.openToast(rentalRequestData);
        }, 100);
      });
  }

  async openToast(rentalRequestData: RentalRequestData) {
    const toast = await this.toastController.create({
      header: `${rentalRequestData.name}, ваша заявка отправлена! С вами свяжутся в ближайшее время`,
      duration: 3000,
      color: 'success',
    });

    await toast.present();
  }

  async openErrorToast() {
    const toast = await this.toastController.create({
      header: `Что-то пошло не так. Попробуйте ещё раз или свяжитесь с нами`,
      duration: 3000,
      color: 'danger',
    });

    await toast.present();
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
